export function initConfetti() {
    const canvas = document.getElementById('confettiCanvas');

    if (canvas) {
        const ctx = canvas.getContext('2d');
        let confettiCount = calculateConfettiCount();

        let confetti = [];

        function random(min, max) {
            return Math.random() * (max - min) + min;
        }

        class ConfettiPiece {
            constructor() {
                this.x = random(0, canvas.width);
                this.y = random(-canvas.height, 0);
                this.r = random(5, 30);
                this.d = random(15, 30);
                this.color = `hsl(${random(0, 360)}, 100%, 50%)`;
                this.tilt = random(-10, 10);
                this.tiltAngleIncrement = random(0.05, 0.12);
                this.tiltAngle = 0;
                this.speedMultiplier = calculateSpeedMultiplier();
                this.shape = Math.random() < 0.33 ? 'circle' : 'line'; // 33% chance for circle
                this.rotation = random(0, 360);
                this.rotationSpeed = random(0.02, 0.05);
                this.scaleX = 1; // Scaling factor for x-axis
                this.scaleXSpeed = random(0.02, 0.05); // Speed of scaling change
                this.lineWidthFactor = random(0.5, 2); // Random factor for line width
            }

            draw() {
                ctx.save();
                ctx.translate(this.x + this.tilt, this.y + this.tilt);
                ctx.rotate(this.rotation);

                if (this.shape === 'circle') {
                    ctx.scale(this.scaleX, 1); // Apply scaling on x-axis
                    ctx.beginPath();
                    ctx.arc(0, 0, this.r / 2, 0, Math.PI * 2);
                    ctx.fillStyle = this.color;
                    ctx.fill();
                } else {
                    const lineWidth = this.r / 2 * this.lineWidthFactor; // Calculate line width
                    ctx.scale(this.scaleX, 1); // Apply scaling on x-axis
                    ctx.lineWidth = lineWidth;
                    ctx.strokeStyle = this.color;
                    ctx.beginPath();
                    ctx.moveTo(-this.r / 4, 0);
                    ctx.lineTo(this.r / 4, 0);
                    ctx.stroke();
                }

                ctx.restore();
            }

            update() {
                this.tiltAngle += this.tiltAngleIncrement;
                this.y += ((Math.cos(this.d) + 3 + this.r / 2) / 2) * this.speedMultiplier;
                this.x += Math.sin(this.d) * this.speedMultiplier;
                this.tilt = Math.sin(this.tiltAngle) * 15;
                this.rotation += this.rotationSpeed;
                this.scaleX = Math.abs(Math.sin(this.tiltAngle)); // Update scale factor for circles

                if (this.y > canvas.height) {
                    this.x = random(0, canvas.width);
                    this.y = random(-canvas.height, 0);
                    this.speedMultiplier = calculateSpeedMultiplier();
                }
                if (this.x > canvas.width) {
                    this.x = 0;
                    this.y = random(-canvas.height, 0);
                    this.speedMultiplier = calculateSpeedMultiplier();
                }
            }
        }

        function calculateConfettiCount() {
            const canvasWidth = canvas.clientWidth;
            const canvasHeight = canvas.clientHeight;
            const baseCount = canvasWidth <= 1920 ? 150 : 300; // Base count for screen width <= 1920
            const widthScaleFactor = canvasHeight / 1920; // Scale factor relative to 1920 width
            const heightScaleFactor = Math.max(0.75, canvasHeight / 1000); // Scale factor relative to 1000 height, min 0.75

            return Math.min(Math.floor(baseCount * widthScaleFactor * heightScaleFactor), 300); // Cap at 300 pieces
        }

        function calculateSpeedMultiplier() {
            const screenHeight = window.innerHeight;
            const minSpeedMultiplier = 0.5;
            const maxSpeedMultiplier = 1;
            const heightScaleFactor = Math.max(minSpeedMultiplier, Math.min(maxSpeedMultiplier, screenHeight / 1000));

            return heightScaleFactor;
        }

        function adjustConfettiCount() {
            const newConfettiCount = calculateConfettiCount();
            if (newConfettiCount !== confettiCount) {
                if (newConfettiCount < confettiCount) {
                    confetti.splice(newConfettiCount);
                } else {
                    for (let i = confettiCount; i < newConfettiCount; i++) {
                        confetti.push(new ConfettiPiece());
                    }
                }
                confettiCount = newConfettiCount;
            }
        }

        function animateConfetti() {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            confetti.forEach(piece => {
                piece.update();
                piece.draw();
            });
            requestAnimationFrame(animateConfetti);
        }

        window.addEventListener('resize', () => {
            canvas.width = canvas.clientWidth;
            canvas.height = canvas.clientHeight;
            adjustConfettiCount();
        });

        // Initial setup
        canvas.width = canvas.clientWidth;
        canvas.height = canvas.clientHeight;
        for (let i = 0; i < confettiCount; i++) {
            confetti.push(new ConfettiPiece());
        }
        animateConfetti();
    }
}
